import Image from '@/src/components/CustomImage'
import classNames from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import React, { useCallback, useEffect, useState } from 'react'
import styles from './index.module.scss'

// 导入图片资源

interface Section5Props {
  message: {
    __management: string
    __logistics: string
    __shippingProcess: string
    __eCommerce: string
    __Integrate: string
    __finance: string
    __leverage: string
    __Integrator: string
    __optimized: string
    __platforms: string
    __empowered: string
  }
}

const Section5: React.FC<Section5Props> = ({ message }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
    dragFree: true
  })

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false)

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setPrevBtnEnabled(emblaApi.canScrollPrev())
    setNextBtnEnabled(emblaApi.canScrollNext())
  }, [emblaApi])

  useEffect(() => {
    if (!emblaApi) return
    onSelect()
    emblaApi.on('select', onSelect)
    emblaApi.on('reInit', onSelect)
  }, [emblaApi, onSelect])
  const pictures = [
    {
      src: '/assets/images/api/icon1_en.png',
      title: message.__logistics,
      description: message.__shippingProcess
    },
    {
      src: '/assets/images/api/icon2_en.png',
      title: message.__eCommerce,
      description: message.__Integrate
    },
    {
      src: '/assets/images/api/icon3_en.png',
      title: message.__finance,
      description: message.__leverage
    },
    {
      src: '/assets/images/api/icon4_en.png',
      title: message.__Integrator,
      description: message.__optimized
    },
    {
      src: '/assets/images/api/icon5_en.png',
      title: message.__platforms,
      description: message.__empowered
    }
  ]

  return (
    <section className={styles.section5}>
      <Image fill src="/assets/images/api/Part5_bg.png" alt="section5 bg" />
      <div className={styles.container}>
        <h2>{message.__management}</h2>
        <div className={styles.carouselContainer}>
          {prevBtnEnabled && (
            <button onClick={scrollPrev} className={classNames(styles.carouselButton, styles.prev)}>
              <ChevronLeft size={32} />
            </button>
          )}
          <div className={styles.listMain} ref={emblaRef}>
            <ul className={styles.list}>
              {pictures.map((item) => (
                <li key={item.title} className={styles.listItem}>
                  <div className={styles.cardHead}>
                    <Image data-yqrole="img" width={85} height={85} src={item.src} alt={item.title} />
                    <h3 className={styles.apiTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.apiDescription}>{item.description}</p>
                </li>
              ))}
            </ul>
          </div>
          {nextBtnEnabled && (
            <button onClick={scrollNext} className={classNames(styles.carouselButton, styles.next)}>
              <ChevronRight size={32} />
            </button>
          )}
        </div>
      </div>
    </section>
  )
}

export default Section5
